import { filter } from "@/model/master/ReportGenerated";
import { getField, updateField } from 'vuex-map-fields';

 
const state = {
    rows: [],
    filter: filter,
    baseModuleUrl : process.env.VUE_APP_MASTER_API_URL + "master-service/master",
};
//TODO find a better way to cleanup the filter
//const filterDefault = Object.assign({}, filter);
const filterDefault = JSON.parse(JSON.stringify(filter));

const getters = {
    getField
};

const actions = {
    loadRowsReport(context){
        context.dispatch("api/post", {
            url: process.env.VUE_APP_REPORT_API_URL + "report-service/mmf/report/reportGenerated/findByFilter",
            data: {}
          }, {root: true})
          .then(data => {
            context.commit("reportGenerated/setRows", data.data, {root: true});
          });
    }
};
const mutations = {
    updateField,
    setRows(state, rows) {
        state.rows = rows;
    },
    setEntity(state, entity) {
        state.entity = entity;
    },
    setClearFilter(state) {
        //TODO find a better way to cleanup the filter
        state.filter = filterDefault;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};